export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registration.vue?vue&type=template&id=2b68a5ef"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/quick-login-reg/registration.vue?vue&type=template&id=2b68a5ef
// module id = Eztz
// module chunks = 0